"use client";

import { useForm } from "react-hook-form";

import { Button } from "@stocks/ui";
import type { ItemResponse } from "@stocks/shared";

import {
  ItemFormFields,
  toItemFormValues,
  toUpdateItemRequest,
  type ItemFormValues,
} from "@/entities/item";

import { useUpdateItem } from "../model/useUpdateItem";

/** 품목 정보 수정 + 사용 중지/재개. 코드는 변경할 수 없다. */
export const ItemEditForm = ({ item }: { item: ItemResponse }) => {
  const form = useForm<ItemFormValues>({ values: toItemFormValues(item) });
  const update = useUpdateItem();

  const onSubmit = (values: ItemFormValues) =>
    update.mutate({ id: item.id, values: toUpdateItemRequest(values) });

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className='flex flex-col gap-4'>
      <ItemFormFields form={form} />
      <div className='flex flex-wrap gap-2'>
        <Button type='submit' disabled={update.isPending}>
          {update.isPending ? "저장 중…" : "저장"}
        </Button>
        <Button
          type='button'
          variant={item.isActive ? "destructive" : "outline"}
          disabled={update.isPending}
          onClick={() => update.mutate({ id: item.id, values: { isActive: !item.isActive } })}
        >
          {item.isActive ? "사용 중지" : "사용 재개"}
        </Button>
      </div>
    </form>
  );
};
